import React from 'react';
import { AdLandingTemplate } from '../../components/templates/AdLandingTemplate';
import { Shield, Target, Zap, Trophy } from 'lucide-react';
export function AfterSchool() {
  return <AdLandingTemplate h1="After-School Kids Activities That Build Confidence" subheadline="Storm Taekwondo gives kids an active, structured after-school activity that teaches focus, discipline, respect, goal setting and resilience." ctaText="Claim Your Child's Free Week" searchIntent="After-School Activities in Farmington Hills" heroImage="https://images.unsplash.com/photo-1517438476312-10d79c077509?auto=format&fit=crop&w=1200&q=80" benefits={[{
    icon: Shield,
    title: 'Confidence Building',
    description: 'Kids learn to stand tall and believe in themselves.'
  }, {
    icon: Target,
    title: 'Improved Focus',
    description: 'Structured drills that help with schoolwork and attention.'
  }, {
    icon: Zap,
    title: 'Positive Energy Outlet',
    description: 'A healthy, active way to burn off after-school energy.'
  }, {
    icon: Trophy,
    title: 'Goal Setting',
    description: 'Earning belts teaches the value of hard work and dedication.'
  }]} whatYouLearn={['Respect for teachers, parents, and peers', 'How to follow multi-step instructions', 'Physical coordination and balance', 'Basic self-defense fundamentals', 'How to handle challenges with resilience']} faqs={[{
    question: 'What time are your after-school classes?',
    answer: 'We have classes starting at 4:30 PM for ages 3-5, and 5:00 PM or 6:00 PM for ages 6 and up, making it easy to fit into your after-school routine.'
  }, {
    question: 'Does my child need experience?',
    answer: 'No experience is needed! Our beginner classes are designed to help new students feel welcome and confident from day one.'
  }, {
    question: 'Is this a daycare program?',
    answer: 'No, we are a structured martial arts school. Parents typically drop off or watch class from our viewing area during the 30-60 minute session.'
  }, {
    question: 'How does the free week work?',
    answer: "Simply fill out the form, and we will contact you to schedule your child's first visit. They can try classes for a full week with no obligation."
  }]} metaTitle="After School Activities Farmington Hills | Storm Taekwondo" metaDescription="Looking for after school activities in Farmington Hills? Storm Taekwondo offers kids martial arts classes that build confidence, focus, and discipline." data-id="element-599" />;
}